import { useEffect } from 'react';

const TICKER_HEIGHT_VAR = '--ticker-height';
const TICKER_SHELL_HEIGHT_VAR = '--ticker-shell-height';

/** Publishes layout offset for sticky header and navigation when the ticker is visible. */
export function useTickerLayout(active: boolean): void {
    useEffect(() => {
        const root = document.documentElement;
        const shellHeight = getComputedStyle(root).getPropertyValue(TICKER_SHELL_HEIGHT_VAR).trim() || '2rem';

        if (active) {
            root.style.setProperty(TICKER_HEIGHT_VAR, shellHeight);
        } else {
            root.style.setProperty(TICKER_HEIGHT_VAR, '0px');
        }

        return () => {
            root.style.setProperty(TICKER_HEIGHT_VAR, '0px');
        };
    }, [active]);
}
